var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast hide",class:_vm.status,attrs:{"role":"alert","aria-live":"assertive","aria-atomic":"true","data-delay":"2000"}},[_c('div',{staticClass:"toast-body"},[_c('i',{staticClass:"icon-filledcheckcircle"}),_vm._v(" "),_c('span',[_vm._v("\n            "+_vm._s(_vm.message)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }